import React from 'react';
import {
  ShieldCheck, Dumbbell, HeartPulse, Weight, Flame, Zap,
  UserCog, Sparkles, BadgeIndianRupee, Users,
} from 'lucide-react';
import { whyUsItems } from '../data/mock';

const iconMap = {
  ShieldCheck, Dumbbell, HeartPulse, Weight, Flame, Zap,
  UserCog, Sparkles, BadgeIndianRupee, Users,
};

export default function WhyUs() {
  return (
    <section id="why-us" className="relative py-20 md:py-32 overflow-hidden" style={{ background: 'linear-gradient(180deg, #0a1428 0%, #0b1a35 100%)' }}>
      <div className="absolute top-0 left-1/4 w-72 h-72 md:w-96 md:h-96 bg-blue-600/10 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-72 h-72 md:w-96 md:h-96 bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="mb-14">
          <p className="section-eyebrow text-amber-400">02 — Why Choose Us</p>
          <h2 className="mt-4 font-anton text-3xl sm:text-4xl md:text-6xl leading-[0.95] text-white">
            EVERYTHING YOU NEED TO <span className="text-blue-500">WIN</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {whyUsItems.map((item, i) => {
            const Icon = iconMap[item.icon] || Dumbbell;
            return (
              <div
                key={item.title}
                className="group relative rounded-2xl p-6 bg-white/[0.03] hover:bg-white/[0.06] border border-white/10 hover:border-blue-500/50 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 fade-up"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-blue-500/15 flex items-center justify-center text-blue-400 group-hover:bg-blue-500/25 group-hover:scale-105 transition">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
                <h3 className="mt-5 text-white font-semibold text-lg">{item.title}</h3>
                <div className="absolute inset-x-6 bottom-0 h-px bg-gradient-to-r from-transparent via-blue-500/40 to-transparent opacity-0 group-hover:opacity-100 transition" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
